<template>
  <v-container fluid>
    <subHeader />
    <v-container fluid style="max-width: 1271px">
      <h2 class="d-flex justify-center pb-1">
        <center>BOOK AND WIN WITH AIR NEW ZEALAND AND UNITED AIRLINES PROMOTION TERMS AND CONDITIONS</center>
      </h2>
      <h2 class="d-flex justify-center pb-8">
        <center>OCTOBER 2025</center>
      </h2>
      <v-row>
        <v-col cols="12" class="pa-0">
          <ol>
            <li>
              Information on how to enter the promotion forms part of the conditions of entry. Entry into the promotion is deemed as acceptance of its terms and conditions. 
            </li>
            <li>
              Entry is only open to all retail and leisure Travel Agents and Brokers, New Zealand-based and IATA-accredited or part of the Travel Industry Designated Service only. The Promoters reserve the right to verify the validity of entries.
            </li>
            <li>
              There is no limit to the number of entries per eligible participant, provided all conditions of entry are met. 
            </li>
            <li>
              Air New Zealand (the “<b>Promoter</b>”) employees and their immediate families, participating agents and their associated agencies are ineligible to enter. The Promoter reserves the right to verify the validity of entries. 
            </li>
            <li>
              Promotion commences Friday 10<sup>th</sup> October 2025 at 08:00NZT and closes Monday 1<sup>st</sup> December 2025 at 23:59NZT (the “<b>Promotional Period</b>”). Sales entries received after this closing time will be ineligible for entry. 
            </li>
            <br>
            <b>Grand Prize Draw</b><br>
            There are eight (8) grand prizes to be won<br><br>

              ● Conditions of Entry:<br>
              How to Enter: <br>
              <ol type="a">
                <li>To enter the grand prize, an eligible participant must visit <a href="#/reward" target="_blank">duo.airnzagent.co.nz/#/reward</a></li>
                <li>Agents must book, and ticket either Air New Zealand 086 ticket stock, or United Airlines 016 ticket stock, flights to/from North America and New Zealand between Friday 10<sup>th</sup> October 2025 and Monday 1<sup>st</sup> December 2025, for travel anytime. </li>
                <li>Eligible flights are those with the origin and destination of New Zealand and USA. Stopovers and transit flights through USA are not permitted.</li>
                <li>Agents must register their Air New Zealand & United booking references through the promotion page on duo.</li>
                <li>Each 086 or 016 booking logged will earn the participant one stamp.</li>
                <li>One booking/PNR = one stamp (NB: Important to note these are <b>per PNR and not per ticket</b>)</li>
                <li>Bookings logged on behalf of another agent are ineligible for entry.</li>
                <li>Agents must enter the correct NZ/UA PNR creation date for the entry to be valid.</li>
                <li>Agents must also complete both the Travel Utah’s training programme (<a href="https://travel.utah.gov/international-media-hub/" target="_blank">https://travel.utah.gov/international-media-hub/</a>) and the California STAR program (<a href="https://star.visitcalifornia.com/login" target="_blank">https://star.visitcalifornia.com/login</a>)</li>
              </ol><br>
              ● The grand prize winners will be drawn based on the highest number of stamps collected via duo. Eight (8) Retail/Leisure agents with the highest number of bookings/PNRs logged win. <br><br>

            <li>
              Grand prize winners will be drawn on or around 5<sup>th</sup> December 2025. Attempts will be made to notify the winner by phone or email provided on their duo profile at the time of the promotion entry. If the Promoter, having used reasonable efforts, is unable to contact the winners prior to 9am Friday 19<sup>th</sup> December 2025, then the prize is forfeited, and a further draw(s) will be conducted. The judge’s decision is final, and no correspondence will be entered into. 
            </li>
            <li>
              Each of the <b>eight</b> winners will win a prize consisting of:<br>
              A spot on the Air New Zealand x United Airlines Famil: <br>
              <ol type="a">
                <li>Return Economy class flights – departing from winners nearest Air New Zealand serviced domestic airport via Auckland to Salt Lake City via San Francisco with United Airlines on 16<sup>th</sup> March 2026. Returning from Los Angeles with Air New Zealand on 25<sup>th</sup> March 2026. </li>
                <li>Six nights in Utah; travelling from Salt Lake City through snowy National Parks, to Las Vegas </li>
                <li>3 nights in Santa Monica</li>
                <li>Airport transfers </li>
                <li>Some meals provided </li>
              </ol>
            </li>
            <li>
              The winner(s) are responsible for paying all additional costs associated with the prize that are not specifically included (as stated in clause 8), including (where applicable) transport, meal costs, spending money, insurance, and all other incidentals.
            </li>
            <li>
              Winners must be full-time travel agents at the time of travel.
            </li>
            <li>
              Travel is for the specified itinerary and dates only (16<sup>th</sup> March – 25<sup>th</sup> March 2026).
            </li>
            <li>
              The prize cannot be converted into cash and is not transferable.
            </li>
            <li>
              The Promoter reserves the right to substitute the prize in whole (or any of its components), with a substitute prize of equal or greater value.
            </li>
            <li>
              All prize travel will be subject to Air New Zealand’s Conditions of Carriage, to view visit <a href="https://www.airnewzealand.co.nz/conditions-of-carriage" target="_blank">https://www.airnewzealand.co.nz/conditions-of-carriage</a>. Prize travel will not be eligible to accrue Airpoints Dollars™ or Status Points and cannot be used in conjunction with Air New Zealand’s Airpoints™ Programme or any other carriers’ frequent flyer schemes. 
            </li>
            <li>
              The Promoter assumes no responsibility for any error, omission, interruption, deletion, defect, delay in operation or transmission, communications line failure, theft or destruction or unauthorised access to or alteration of entries. The Promoter assumes no responsibility for any injury or damage to participants or any other person’s computer related to or resulting from participation in or down-loading any materials in this promotion. Entries into this promotion will be stored only in the Air New Zealand duo.
            </li>
            <li>
              Neither the Promoter nor any other person or party associated with this promotion shall be liable for any loss or damage whatsoever suffered (including but not limited to indirect or consequential loss) or personal injury suffered or sustained in connection with either participation in this promotion or with any prizes offered.
            </li>
            <li>
              By providing any information to Air New Zealand and United Airlines online or offline, you consent to the collection and use of such information by named Airlines, its affiliates, partners, contractors and permitted agents as herein described and consistent with applicable laws.
            </li>
            <li>
              The Promoter collects entrants’ personal information in order to conduct the promotion. If the information requested is not provided, the entrant may not participate in the promotion. Acceptance of the prize is deemed consent for the Promoter to use the winner’s details and photographs for promotional and media purposes without any further reference, payment or other compensation to the entrant. Please refer to Air New Zealand’s Privacy Statement at <a href="https://www.airnewzealand.co.nz/privacy" target="_blank">https://www.airnewzealand.co.nz/privacy</a> regarding the collection, use, disclosure and storage of personal information.
            </li>
            <li>
              The Promotion may be modified or withdrawn by the Promotor at any time acting reasonably (including by changing or cancelling a particular Local Event(s)).
            </li>
            <li>
              The Promoters of this competition are Air New Zealand Limited, Private Bag 92007, Auckland, New Zealand and United Airlines 233 S. Wacker Drive, Chicago, Illinois 60606
            </li>
          </ol>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<style scoped>
.video-title {
  font-size: 28px;
  font-family: "AirNZ Sans Semibold";
  float: left;
}

h1 {
  font-family: "AirNZ Black Italic";
  font-size: 38px;
}

h2 {
  font-family: "AirNZ Sans Semibold";
  font-size: 25px;
}

h3 {
  font-family: "AirNZ Sans Semibold";
  font-size: 21px;
}

p,
a {
  margin-top: 21px;
  font-family: "AirNZ Sans Regular";
  font-size: 17px;
}
@counter-style list-style-custom {
  system: extends lower-alpha;
  suffix: '). ';
}
</style>

<script>
/* eslint-disable no-console */
import subHeader from "./subHeader.vue";

export default {
  components: {
    subHeader,
  },
  mounted: function () {
    window.scrollTo(0, 0);
  },
};
</script>
